import { authExchange } from '@urql/exchange-auth'
import { errorExchange, makeOperation } from '@urql/vue'
import { useMainStore } from '~~/stores/main'
import { jwtDecode } from 'jwt-decode'

interface IAuthState {
  authToken: string
  refreshToken: string
}

export const AuthExchange = authExchange(async (utils) => {
  const store = useMainStore()
  const config = useRuntimeConfig()

  return {
    addAuthToOperation(operation) {
      if (!store.auth || !store.auth.authToken) return operation
      return utils.appendHeaders(operation, {
        authorization: store.auth.authToken,
      })
    },
    didAuthError(error) {
      return error.graphQLErrors.some(
        (e) => e.extensions?.code === 'UNAUTHENTICATED',
      )
    },
    async refreshAuth() {
      let token: IAuthState

      try {
        if ((store.auth as any)?.refreshToken) {
          token = await $fetch('/auth/refresh', {
            baseURL: config.public.apiHost,
            method: 'post',
            body: {
              refreshToken: (store.auth as any)?.refreshToken,
            },
          })
        }
      } catch (e) {
        console.warn('Token outdated')
      }

      if (token?.authToken && token?.refreshToken) {
        const decoded = jwtDecode<{
          username: string
          email: string
          sub: number
          languageId: number
          channelId: number
          // userChannels: any[]
          channels: number[],
          languages: number[]
        }>(token.authToken)

        store.auth = {
          authToken: token.authToken,
          refreshToken: token.refreshToken,
          user: {
            ...decoded,
            id: decoded.sub,
            name: decoded.username,
            userChannels: []
          },
        }
      } else {
        const router = useRouter()
        localStorage.clear()
        store.auth = {}
        router.push('/login')
      }
    },
  }
})

// export const AuthExchange = authExchange(async utils => ({
//   addAuthToOperation: ({ authState, operation }) => {
//     // the token isn't in the auth state, return the operation without changes
//     if (!authState || !(authState as IAuthState).authToken) {
//       return operation;
//     }

//     // fetchOptions can be a function (See Client API) but you can simplify this based on usage
//     const fetchOptions =
//       typeof operation.context.fetchOptions === "function"
//         ? operation.context.fetchOptions()
//         : operation.context.fetchOptions || {};

//     return makeOperation(operation.kind, operation, {
//       ...operation.context,
//       fetchOptions: {
//         ...fetchOptions,
//         headers: {
//           ...fetchOptions.headers,
//           authorization: (authState as IAuthState).authToken,
//         },
//       },
//     });
//   },
//   willAuthError: ({ authState }) => {
//     if (!authState) return true;
//     // e.g. check for expiration, existence of auth etc
//     return false;
//   },
//   didAuthError: ({ error }) => {
//     // check if the error was an auth error (this can be implemented in various ways, e.g. 401 or a special error code)
//     return error.graphQLErrors.some(
//       (e) => e.extensions?.code === "UNAUTHENTICATED"
//     );
//   },
//   getAuth: async ({ authState }) => {
//     const store = useMainStore();
//     const config = useRuntimeConfig();

//     // for initial launch, fetch the auth state from storage (local storage, async storage etc)
//     if (!authState) {
//       const authToken = store.auth.authToken;
//       const refreshToken = store.auth.refreshToken;
//       if (authToken && refreshToken) {
//         return { authToken, refreshToken };
//       }
//       return null;
//     }

//     /**
//      * the following code gets executed when an auth error has occurred
//      * we should refresh the token if possible and return a new auth state
//      * If refresh fails, we should log out
//      **/
//     let token: IAuthState;
//     try {
//       token = await $fetch("/auth/refresh", {
//         baseURL: config.public.apiHost,
//         method: "post",
//         body: {
//           refreshToken: (authState as any)?.refreshToken,
//         },
//       });
//     } catch (e) {
//       console.warn("Token outdated");
//       const router = useRouter();
//       localStorage.clear()
//       return router.push("/login");
//     }

//     if (token?.authToken && token?.refreshToken) {
//       const { username, email, sub } = jwtDecode<{
//         username: string;
//         email: string;
//         sub: number;
//       }>(token.authToken);

//       // save the new tokens in storage
//       store.auth = {
//         authToken: token.authToken,
//         refreshToken: token.refreshToken,
//         user: {
//           id: sub,
//           name: username,
//           email,
//         },
//       };

//       // return the new tokens
//       return {
//         authToken: store.auth.authToken,
//         refreshToken: store.auth.refreshToken,
//       };
//     }

//     // otherwise, if refresh fails, log clear storage and log out
//     localStorage.clear();
//     store.auth = {};
//     // your app logout logic should trigger here
//     // logout();

//     return null;
//   },
// }));

export const AuthErrorExchange = errorExchange({
  onError(error, operation) {
    console.log('Got error:', error)
    const router = useRouter()
    if (error && error.message.includes('Unauthorized')) {
      console.log('Got Auth error, redirecting to /login...')
      router.push('/login')
      return error
    }
    if (error && error.message.includes('Foreign key constraint')) {
      error.message = 'This item is in use by something else.'
    }
    if (error && error.message.includes('Forbidden')) {
      // Mutations: do not redirect — callers can show the error; redirect felt like "nothing happened"
      if (operation?.kind === 'mutation') {
        return { error }
      }
      router.replace('/403')
    }
    return { error }
  },
})
